import Button from 'components/base/Button';
import { cartItems } from 'data/e-commerce/products';
import { currencyFormat } from 'helpers/utils';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { RootState } from 'redux-state/store';

const CheckoutSummaryCard = () => {
  const { vendorId } = useParams();
  const navigate = useNavigate();
  const { cart } = useSelector((state: RootState) => state.user.cart);

  const vendorCart = cart?.find(item => item.vendorId === vendorId) || cart[0];
  if (!vendorCart) return null;

  const navigateToCart = () => {
    navigate('/cart');
  };

  return (
    <Card>
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h3 className="mb-0">Summary</h3>
          <Button
            variant="link"
            className="pe-0"
            type="button"
            onClick={navigateToCart}
          >
            Edit cart
          </Button>
        </div>
        <div className="border-dashed border-bottom border-translucent mb-4">
          <div className="ms-n2 mb-5">
            {vendorCart?.products.map(item => (
              <Row className="align-items-center g-3 mb-2" key={item.productId}>
                <Col xs={7} md={6} lg={7}>
                  <div className="d-flex align-items-center">
                    <img
                      className="me-2 ms-1"
                      src={item.thumbnail}
                      width={40}
                      alt={item.name}
                    />
                    <h6 className="fw-semibold text-body-highlight lh-base line-clamp-2">
                      {item.name}
                    </h6>
                  </div>
                </Col>
                <Col xs={2} md={3} lg={2}>
                  <h6 className="fs-9 mb-0">x{item.quantity}</h6>
                </Col>
                <Col xs={3} className="ps-0">
                  <h5 className="mb-0 fw-semibold text-end fs-9">
                    {currencyFormat(item.price * item.quantity, {
                      currency: 'SAR'
                    })}
                  </h5>
                </Col>
              </Row>
            ))}
          </div>
        </div>

        <div className="border-dashed border-bottom border-translucent mb-3">
          <div className="d-flex justify-content-between mb-2">
            <h5 className="text-body fw-semibold">Items subtotal: </h5>
            <h5 className="text-body fw-semibold">
              {currencyFormat(vendorCart?.totalAmount, {
                currency: 'SAR'
              })}
            </h5>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <h5 className="text-body fw-semibold">Discount: </h5>
            {vendorCart && vendorCart.coupon && (
              <h5 className="text-danger fw-semibold">
                {vendorCart.coupon.discountAmount}
              </h5>
            )}
          </div>
          <div className="d-flex justify-content-between mb-2">
            <h5 className="text-body fw-semibold">Tax: </h5>
            <h5 className="text-body fw-semibold">0</h5>
          </div>
          <div className="d-flex justify-content-between mb-2">
            <h5 className="text-body fw-semibold">Subtotal </h5>
            <h5 className="text-body fw-semibold">
              {currencyFormat(vendorCart?.totalAmount, {
                currency: 'SAR'
              })}
            </h5>
          </div>
          <div className="d-flex justify-content-between mb-3">
            <h5 className="text-body fw-semibold">Shipping Cost </h5>
            <h5 className="text-body fw-semibold">0 </h5>
          </div>
        </div>

        <div className="d-flex justify-content-between">
          <h4 className="mb-0">Total :</h4>
          <h4 className="mb-0">
            {currencyFormat(
              (vendorCart.totalAmountAfterDiscount ?? vendorCart.totalAmount) ||
                0,
              {
                currency: 'SAR'
              }
            )}
          </h4>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CheckoutSummaryCard;
